import { render, staticRenderFns } from "./deleteAccount.vue?vue&type=template&id=7f44580d&scoped=true"
import script from "./deleteAccount.vue?vue&type=script&lang=js"
export * from "./deleteAccount.vue?vue&type=script&lang=js"
import style0 from "./deleteAccount.vue?vue&type=style&index=0&id=7f44580d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f44580d",
  null
  
)

export default component.exports